<template>
    <div class="box__components--prize">
        <div class="d-flex justify-content-end mb-3" style="gap: 12px">
            <button
                v-if="checkPermission('prize.edit')"
                type="button"
                class="btn btn-common-sml btn-primary"
                style="white-space: nowrap"
                @click="handleAddTitle()"
            >
                賞品タイトルを追加
            </button>
        </div>

        <div class="table-responsive table-prize">
            <table class="table table-bordered custom__table--sticky">
                <thead>
                    <tr :class="{ noteFix: arrayObjectPizes.length > 0 }">
                        <th
                            v-for="(item, k) in configTable.headers"
                            :key="k"
                            :style="{ 'background-color': item.bgr }"
                            style="white-space: nowrap; padding: 0.5rem"
                        >
                            <div class="d-flex align-items-center" style="min-width: max-content; gap: 5px">
                                {{ item.label }}
                                <span v-if="item.required" class="text-danger">*</span>
                            </div>
                        </th>
                    </tr>
                    <tr :key="`prize-detail-each-title`" :class="{ 'prize__detail--title': arrayObjectPizes.length > 0 }">
                        <th
                            v-for="(child, childIdx) in configTable.headersChild"
                            :key="`child-${childIdx}`"
                            :style="{ 'background-color': child.bgr }"
                            style="white-space: nowrap; padding: 0.5rem"
                        >
                            <div class="d-flex align-items-center" style="gap: 5px">
                                {{ child.label }}
                                <span v-if="child.required" class="text-danger">*</span>
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(item, k) in arrayObjectPizes">
                        <tr :key="k" style="border-top: 2px solid #b3b7bb">
                            <td style="vertical-align: middle; text-align: center">
                                <div class="d-flex" style="gap: 0.5rem">
                                    <p class="mb-0">
                                        {{ k + 1 }}
                                    </p>
                                </div>
                            </td>

                            <!-- 賞品タイトル/ title phần thưởng -->
                            <td style="vertical-align: middle">
                                <div style="min-width: 200px">
                                    <InputText
                                        :id="`賞品タイトル${k}`"
                                        :model.sync="item.title"
                                        :config.sync="item.configTitle"
                                        @change="onHandleChangeTitle(item)"
                                    />
                                </div>
                            </td>

                            <!-- 種類/ phân loại  -->
                            <td style="vertical-align: middle; text-align: center">
                                <div>
                                    <ModalTypeTitle
                                        v-if="isActiveComponent(null, k, activedType)"
                                        :id="`popup-type-${k}`"
                                        :title="item.title"
                                        :isShow.sync="configModalTypeTitle.model"
                                        :dataTypes.sync="item.types"
                                        :masterTypes="listTypeTitle"
                                        :isHighCouponValue.sync="item.is_high_coupon_value"
                                    />
                                    <button type="button" class="btn btn-sm btn-primary mb-0" @click="handleOpenType(null, k)">
                                        {{ $t('pageCampaign.tabPrize.type') }}
                                    </button>
                                </div>
                            </td>

                            <!-- 当選人数/ số người trúng  -->
                            <td style="vertical-align: middle">
                                <div style="min-width: 115px">
                                    <InputText
                                        :id="`winners${k}`"
                                        :model.sync="item.number_of_win_prize"
                                        :config="{
                                            classCustom: 'text-center',
                                            isNumber: true,
                                            maxlength: 10,
                                            error: false
                                        }"
                                        @input="handleMath(item)"
                                    />
                                </div>
                            </td>

                            <!-- 抽選人数/ số người bốc thăm  -->
                            <td style="vertical-align: middle">
                                <div style="min-width: 120px">
                                    <InputText
                                        :id="`drawn${k}`"
                                        :model.sync="item.number_of_people_drawing_lots"
                                        :config="{
                                            classCustom: 'text-center',
                                            isNumber: true,
                                            maxlength: 10,
                                            error: false
                                        }"
                                    />
                                </div>
                            </td>

                            <!-- 発送・進呈予定日/ ngày dự định theo lịch, giao hàng -->
                            <td style="vertical-align: middle">
                                <div style="min-width: 150px">
                                    <PickerDate :id="`deliveryDateSchedule${k}`" :model.sync="item.delivery_date_schedule" />
                                </div>
                            </td>

                            <!-- 発送日・進呈日/ ngày dự định, giao hàng  -->
                            <td style="vertical-align: middle">
                                <div style="min-width: 150px">
                                    <PickerDate :id="`deliveryDate${k}`" :model.sync="item.delivery_date" />
                                </div>
                            </td>

                            <!-- 発送件数/ số lượng giao hàng  -->
                            <td style="vertical-align: middle">
                                <div style="min-width: 115px">
                                    <InputText
                                        :id="`deliveryQuantity${k}`"
                                        :model.sync="item.delivery_quantity"
                                        :config.sync="item.configDeliveryQuantity"
                                        @input="handleMath(item)"
                                    />
                                </div>
                            </td>

                            <!-- 戻り詳細/ chi tiết trả về -->
                            <td style="vertical-align: middle; text-align: center">
                                <div style="min-width: max-content; margin-top: 5px">
                                    <button type="button" class="btn btn-sm btn-primary mb-0" @click="handleOpenDetailReturn(null, k)">
                                        {{ $t('pageCampaign.tabPrize.returnDetails') }}
                                    </button>
                                    <ModalDetailsReturns
                                        v-if="isActiveComponent(null, k, activeModalDetailsReturns)"
                                        :id="`modal-detail-return-${k}`"
                                        :isShow.sync="configDetailReturn.model"
                                        :dataDetailReturns.sync="item.return_prize_items"
                                        :returnPrizeItemsCount.sync="item.return_prize_items_count"
                                    />
                                </div>
                            </td>

                            <!-- 戻り件数/ số phần thưởng trả về -->
                            <td>
                                <div
                                    class="text__ellipsi--result"
                                    v-b-tooltip.hover
                                    :title="item.return_prize_items_count"
                                    style="width: 50px"
                                    :style="`transform: ${item.arrayNameAndQuantity.length > 1 ? '' : 'translateY(10px)'}`"
                                >
                                    {{ item.return_prize_items_count }}
                                </div>
                            </td>

                            <td style="vertical-align: middle; text-align: center">
                                <div>
                                    <button
                                        type="button"
                                        class="btn btn-sm"
                                        style="white-space: nowrap; outline: none; box-shadow: none"
                                        @click="handleActivePrizesForTitle(item)"
                                    >
                                        <i v-if="item.isActivePrize" class="mdi mdi-chevron-double-down" style="color: #5664d2; font-size: 20px"></i>
                                        <i v-else class="mdi mdi-dots-horizontal" style="color: #5664d2; font-size: 20px"></i>
                                    </button>
                                </div>
                            </td>

                            <td style="vertical-align: middle; text-align: center">
                                <div>
                                    <button type="button" class="btn btn-sm btn-danger" style="white-space: nowrap" @click="handleRemoveTitle(k)">
                                        {{ $t('btn.delete') }}
                                    </button>
                                </div>
                            </td>
                        </tr>
                        <template v-if="item.isActivePrize">
                            <tr
                                v-for="(itemPN, idx) in item.arrayNameAndQuantity"
                                :key="'arrayObjectPizes' + k + idx"
                                :class="{
                                    noteFix: idx == 0
                                }"
                            >
                                <td style="vertical-align: middle">
                                    <div>
                                        <InputCheckBox
                                            v-if="idx == 0"
                                            v-b-tooltip.hover="`${$t('pageCampaign.tabPrize.noteUniquePrize')}`"
                                            class=""
                                            :model.sync="item.is_copy_title_prize"
                                            :id="`check-copy-title_prize${k}-${idx}`"
                                            :value="item.is_copy_title_prize"
                                            :label="`${$t('pageCampaign.tabPrize.samePrize')}`"
                                            :disabled="item.arrayNameAndQuantity?.length > 1"
                                            @change="onHandleCheckCopy(item)"
                                        />
                                    </div>
                                </td>

                                <!-- 賞品名/ tên phần thưởng  -->
                                <td>
                                    <div
                                        class="d-flex justify-content-between"
                                        style="gap: 10px"
                                        :key="idx"
                                        :class="{
                                            'mb-3': item.arrayNameAndQuantity.length !== 1
                                        }"
                                    >
                                        <div class="d-flex align-items-center" style="gap: 12px">
                                            <!-- <div>
                                                <button
                                                    style="width: 30px"
                                                    type="button"
                                                    class="btn btn-sm btn-warning rounded-circle"
                                                    :disabled="!itemPN.id"
                                                    @click="handlePushToDetail(itemPN)"
                                                >
                                                    <i class="fa fa-info"></i>
                                                </button>
                                            </div> -->

                                            <button
                                                :disabled="item.is_copy_title_prize"
                                                type="button"
                                                class="btn btn-sm btn-info rounded-circle"
                                                @click.prevent="addNameAndQuantity(idx, k)"
                                            >
                                                <i class="fa fa-plus"></i>
                                            </button>
                                            <button
                                                type="button"
                                                class="btn btn-sm btn-danger rounded-circle"
                                                :disabled="item.arrayNameAndQuantity.length <= 1"
                                                @click.prevent="removeNameAndQuantity(idx, k)"
                                            >
                                                <i class="fa fa-minus"></i>
                                            </button>

                                            <div class="d-flex align-center">
                                                <InputCheckBox
                                                    class=""
                                                    :model.sync="itemPN.is_related_to_shipping"
                                                    :id="`check-each-prize${k}-${idx}`"
                                                    :value="itemPN.is_related_to_shipping"
                                                    :label="``"
                                                />
                                                <p class="m-0" style="font-size: 12px; padding-top: 2px">
                                                    {{ $t('pageCampaign.tabPrize.selectShipping') }}
                                                </p>
                                            </div>
                                        </div>
                                        <div style="min-width: 200px">
                                            <InputText
                                                :id="`prize-name${k}-${idx}`"
                                                :model.sync="itemPN.name"
                                                :config="itemPN.configPrizeName"
                                                :disabled="item.is_copy_title_prize"
                                            />
                                        </div>
                                    </div>
                                </td>

                                <!-- 数量/ số lượng cho từng phần thưởng  -->
                                <td>
                                    <div
                                        :class="{
                                            'mb-3': item.arrayNameAndQuantity.length !== 1
                                        }"
                                        style="min-width: 115px"
                                    >
                                        <InputText
                                            :id="`quantity${k}-${idx}`"
                                            :model.sync="itemPN.quantity"
                                            :config="{
                                                classCustom: 'text-center',
                                                isNumber: true,
                                                maxlength: 10,
                                                error: false
                                            }"
                                            @input="handleMath(item)"
                                        />
                                    </div>
                                </td>

                                <!-- 賞品必要数/ số lượng phần thưởng cần thiết  -->
                                <td>
                                    <div class="text__ellipsi--result" v-b-tooltip.hover :title="itemPN.quantity_for_event_prize">
                                        {{ itemPN.quantity_for_event_prize }}
                                    </div>
                                </td>

                                <!-- 入庫予定日/ ngày dự định nhập kho  -->
                                <td>
                                    <div style="min-width: 150px">
                                        <PickerDate :id="`scheduled_arrived_at${k}-${idx}`" :model.sync="itemPN.scheduled_arrived_at" />
                                    </div>
                                </td>

                                <!-- 入庫日/ ngày nhập kho -->
                                <td>
                                    <div style="min-width: 150px">
                                        <PickerDate :id="`warehousing_date${k}-${idx}`" :model.sync="itemPN.warehousing_date" />
                                    </div>
                                </td>

                                <!-- 入庫数/ số lượng nhập kho  -->
                                <td>
                                    <div style="min-width: 115px">
                                        <InputText
                                            :id="`warehousing_quantity${k}-${idx}`"
                                            :model.sync="itemPN.warehousing_quantity"
                                            :config.sync="itemPN.configWarehousingQuantity"
                                            @input="handleMath(item)"
                                        />
                                    </div>
                                </td>

                                <!-- 残予定数/ số lượng dự định còn  -->
                                <td>
                                    <div
                                        class="text__ellipsi--result"
                                        v-b-tooltip.hover
                                        :title="itemPN.estimated_remaining_quantity"
                                        :style="{ color: itemPN.configEstimatedRemainingQuantity.hasWarning ? '#ff3d60' : '' }"
                                    >
                                        {{ itemPN.estimated_remaining_quantity }}
                                    </div>
                                </td>

                                <!-- メモ（連絡事項）/ memo (mục liên lạc) -->
                                <td>
                                    <div style="min-width: 150px">
                                        <InputText :id="`memo${k}-${idx}`" :model.sync="itemPN.memo" :config="itemPN.configMemo" />
                                    </div>
                                </td>

                                <!-- 詳細情報? thông tin chi tiết  -->
                                <td style="text-align: center">
                                    <div style="min-width: max-content; margin-top: 5px">
                                        <PopUpInfomation
                                            v-if="isActiveComponent(idx, k, activedInfo)"
                                            :id="`popup-info-${k}-${idx}`"
                                            :title="itemPN.name"
                                            :isShow.sync="configPopInfomation.isShow"
                                            :dataInfo.sync="itemPN.detail_information"
                                        />
                                        <PopoverPreviewInfo
                                            :id="`popover-infomation-${idx}-${k}`"
                                            :title="itemPN.name"
                                            :dataPreview="itemPN.detail_information"
                                        >
                                            <button
                                                :id="`popover-infomation-${idx}-${k}`"
                                                type="button"
                                                class="btn btn-sm btn-primary"
                                                @click="handleShowPopupInfo(idx, k)"
                                            >
                                                {{ $t('pageCampaign.tabPrize.detailedInformation') }}
                                            </button>
                                        </PopoverPreviewInfo>
                                    </div>
                                </td>

                                <!-- 実あまり数/ số lượng còn lại thực tế -->
                                <td>
                                    <div
                                        class="text__ellipsi--result"
                                        v-b-tooltip.hover
                                        :title="itemPN.remaining_quantity"
                                        :style="{ color: itemPN.configRemainingQuantity.hasWarning ? '#ff3d60' : '' }"
                                    >
                                        {{ itemPN.remaining_quantity }}
                                    </div>
                                </td>

                                <!-- あまり対応/ đối ứng còn thừa -->
                                <td style="text-align: center">
                                    <div style="min-width: max-content; margin-top: 5px">
                                        <PopUpCompatible
                                            v-if="isActiveComponent(idx, k, activeCompatible)"
                                            :id="`popup-compatible-${k}-${idx}`"
                                            :title="itemPN.name"
                                            :isShow.sync="configPopCompatible.isShow"
                                            :dataCompatible.sync="itemPN.remaining_response"
                                        />
                                        <PopoverPreviewCompatible
                                            :id="`popover-preview-compatible-${idx}-${k}`"
                                            :title="itemPN.name"
                                            :dataPreview="itemPN.remaining_response"
                                        >
                                            <button
                                                :id="`popover-preview-compatible-${idx}-${k}`"
                                                type="button"
                                                class="btn btn-sm btn-primary"
                                                @click="handleShowPopupCompatible(idx, k)"
                                            >
                                                {{ $t('pageCampaign.tabPrize.notVeryCompatible') }}
                                            </button>
                                        </PopoverPreviewCompatible>
                                    </div>
                                </td>
                            </tr>
                        </template>
                    </template>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import { masterMethods } from '@/state/helpers';
import { checkPermission } from '@/utils/handlers';
import { InputText, InputCheckBox } from '@/components/Input';
import { initObjectPize, handleExcuteMath, handleAddNamePrize } from './index';
import { CONFIG_TABLE, CONFIG_INFOMATION, CONFIG_COMPATIBLE, CONFIG_MODAL_DETAIL_RETURN, CONFIG_MODALTYPETITLE } from './constans';

import PickerDate from '@/components/DateCustoms/PickerDate/main.vue';
import PopUpInfomation from './components/Infomation/pop-up-infomation.vue';
import PopoverPreviewInfo from './components/Infomation/popover-preview.vue';
import PopUpCompatible from './components/NotVeryCompatible/pop-up-compatible.vue';
import PopoverPreviewCompatible from './components/NotVeryCompatible/popover-preview.vue';
import ModalDetailsReturns from './components/ModalDetailsReturns/main.vue';
import ModalTypeTitle from './components/ModalTypeTitle/main.vue';

export default {
    props: {
        dataEventPrizes: {
            type: Array,
            default: () => []
        },
        dataPrizes: {
            type: Array,
            default: () => []
        },
        listTypeTitle: {
            type: Array,
            default: () => []
        }
    },
    components: {
        InputText,
        InputCheckBox,
        PickerDate,
        PopUpInfomation,
        PopoverPreviewInfo,
        PopUpCompatible,
        PopoverPreviewCompatible,
        ModalDetailsReturns,
        ModalTypeTitle
    },
    data() {
        return {
            arrayObjectPizes: [],
            configTable: CONFIG_TABLE,
            configPopInfomation: CONFIG_INFOMATION,
            configPopCompatible: CONFIG_COMPATIBLE,
            configDetailReturn: CONFIG_MODAL_DETAIL_RETURN,
            configModalTypeTitle: CONFIG_MODALTYPETITLE,
            activedInfo: null,
            activeCompatible: null,
            activeModalDetailsReturns: null,
            activedType: null
        };
    },
    methods: {
        ...masterMethods,
        checkPermission,

        handleAddTitle() {
            this.arrayObjectPizes.push(initObjectPize());
        },

        handleRemoveTitle(index) {
            this.arrayObjectPizes.splice(index, 1);
        },

        addNameAndQuantity(idChild, idParent) {
            handleAddNamePrize(this.arrayObjectPizes, idChild, idParent);
        },

        removeNameAndQuantity(idChild, idParent) {
            this.arrayObjectPizes[idParent].arrayNameAndQuantity.splice(idChild, 1);
        },

        handleMath(obj) {
            handleExcuteMath(obj);
        },

        handleShowPopupInfo(idx, k) {
            this.activedInfo = { idx, k };
            this.activeCompatible = null;
            this.configPopInfomation.isShow = true;
        },

        handleShowPopupCompatible(idx, k) {
            this.activeCompatible = { idx, k };
            this.activedInfo = null;
            this.configPopCompatible.isShow = true;
        },

        handleOpenDetailReturn(idx, k) {
            this.activeModalDetailsReturns = { idx, k };
            this.configDetailReturn.model = true;
        },

        handleOpenType(idx, k) {
            this.activedType = { idx, k };
            this.configModalTypeTitle.model = true;
        },

        isActiveComponent(idx, k, btnActive) {
            return btnActive && btnActive.idx === idx && btnActive.k === k;
        },

        handlePushToDetail(item) {
            this.$router.push({
                path: '/prize/form/view',
                query: {
                    id: item.id
                }
            });
        },

        handleActivePrizesForTitle(param) {
            if (param.isActivePrize) {
                param.isActivePrize = false;
            } else {
                param.isActivePrize = true;
            }
        },

        onHandleChangeTitle(objTitle) {
            if (!objTitle.is_copy_title_prize) return;
            objTitle.arrayNameAndQuantity[0].name = objTitle.title;
        },

        onHandleCheckCopy(objTitle) {
            this.onHandleChangeTitle(objTitle);
        }
    },
    watch: {
        dataEventPrizes: {
            handler(newDataEventPrizes) {
                if (newDataEventPrizes.length > 0) {
                    newDataEventPrizes.forEach((item) => {
                        this.arrayObjectPizes.push(initObjectPize(item));
                    });
                    this.$emit('update:dataPrizes', this.arrayObjectPizes);
                } else {
                    this.arrayObjectPizes = [];
                }
            },
            immediate: true
        },
        arrayObjectPizes: {
            handler(newArrayObjectPizes) {
                this.$emit('update:dataPrizes', newArrayObjectPizes);
            },
            deep: true
        }
    },
    mounted() {}
};
</script>
<style lang="scss">
.box__preview--common {
    min-width: 170px;
    &--title {
        margin-left: 5px;
        min-width: max-content;
        font-size: 12px;
    }
    &--content {
        margin-left: 10px;
        font-size: 12px;
        margin-bottom: 0;
    }
}
</style>
<style lang="scss" scoped>
.text__ellipsi--result {
    text-align: center;
    max-width: 115px;
    overflow: hidden;
    transform: translateY(10px);
    white-space: nowrap;
    text-overflow: ellipsis;
}
</style>
